import React, { useState } from 'react'
import './userlogin.scss'


const CreateAccount = () => {

   
    const [emailEmpty, setEmailEmpty] = useState()
    const [email, setEmail] = useState()
    const [showNoValidEmail, setShowNoValidEmail] = useState()
    const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

    const validateEmail = (e) => {
        if (e.target?.value && e.target.value.match(isValidEmail)) {
            setShowNoValidEmail(false);
            setEmail(e.target.value)
           
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()
       
       // console.log(email, 'email')
        !email && setEmailEmpty(true)
        if (email && email.length && email.match(isValidEmail)) {
          //  console.log('email is here and it is fully validated')
            let url =  'http://localhost:3000/finishaccount'
            
          //  console.log(url)
//
            fetch(`http://dev.ebillet.dk/systemnative/customer.asmx/SendCreateLink?Email=${email}&URL=${url}`, {
                method: "GET",            
            })
                .then((res) => console.log(res))

        }
        else if (email.length && !email.match(isValidEmail)){
            setShowNoValidEmail(true);
        }
    };

    const emailChanged = (e) => {
       
        setEmail(e.target.value)
        setEmailEmpty(false)
        validateEmail(e)
    }
    return (
        <div className="login" >
            <p className='profile'>Opret profil</p>
            <p className='emailtext'>Indtast din email</p>
            <p className='emailinfo'>Indtast din email for at modtage et link til at oprette din konto</p>

            <form onSubmit={(e)=>handleSubmit(e)} style={{ marginTop: '30px' }}>
                <label className='email-label'>Email</label>
                <input className='email-input' style={{ border: emailEmpty === true ? '3px solid red' : '' }} placeholder='Indtast email' onChange={(e) => emailChanged(e)} />
                {emailEmpty === true ? <p className='email-error'>Venligst indtast din email</p> : null}
                {showNoValidEmail === true ? <p className = 'email-error'>Email er ikke gyldig</p> : null}
          
                <button type="submit" className='send_btn'>Send oprettelseslink </button>
            </form>
        </div>)
}

export default CreateAccount